<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addRecommendation") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #091647">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-with-scroll
            col="12"
            :optionsList="users"
            :placeholder="$t('SIDENAV.Clients.name')"
            v-model="data.user"
            required
            :hasMore="usersHasMore"
            :isLoading="usersLoading"
            :internal-search="false"
            @loadMore="loadMoreUsers"
            @search-change="searchUsers"
          />

          <!-- Start:: Recommendations Repeater -->
          <div class="col-12">
            <div
              class="row align-items-center"
              v-for="(item, index) in data.recommendations"
              :key="index"
            >
              <base-select-input
                col="5"
                :optionsList="recommendationLists"
                :placeholder="$t('PLACEHOLDERS.recommendation_list')"
                :taggable="true"
                :tagPlaceholder="$t('PLACEHOLDERS.press_enter_to_add_list')"
                @tag="onAddListTag($event, index)"
                v-model="item.recommendation_list_id"
                required
              />
              <base-select-with-scroll
                col="5"
                :optionsList="influencers"
                :placeholder="$t('PLACEHOLDERS.influencer_name')"
                v-model="item.influencer"
                required
                :multiple="true"
                :focus="false"
                :disabled="!influencers"
                :style="!influencers ? 'cursor: wait;' : ''"
                :hasMore="influencersHasMore"
                :isLoading="influencersLoading"
                :internal-search="false"
                @loadMore="loadMoreInfluencers"
                @search-change="searchInfluencers"
              />
              <div class="col-2">
                <div class="d-flex align-center justify-start h-100">
                  <v-btn
                    fab
                    x-small
                    color="error"
                    class="mx-1"
                    @click="removeRow(index)"
                    v-if="data.recommendations.length > 1"
                    elevation="0"
                  >
                    <i class="fas fa-minus white--text"></i>
                  </v-btn>
                  <v-btn
                    fab
                    x-small
                    color="success"
                    class="mx-1"
                    @click="addRow"
                    v-if="index === data.recommendations.length - 1"
                    elevation="0"
                  >
                    <i class="fas fa-plus white--text"></i>
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- <div class="col-12 mt-2">
              <v-btn color="primary" @click="addRow">
                <v-icon left>mdi-plus</v-icon> {{ $t("BUTTONS.add_row") }}
              </v-btn>
            </div> -->
          </div>
          <!-- End:: Recommendations Repeater -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CreateRecommendation",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      users: [],
      influencers: [],
      recommendationLists: [],

      // Users Pagination & Search
      usersPage: 1,
      usersHasMore: true,
      usersLoading: false,
      usersSearch: "",
      usersSearchTimeout: null,

      // Influencers Pagination & Search
      influencersPage: 1,
      influencersHasMore: true,
      influencersLoading: false,
      influencersSearch: "",
      influencersSearchTimeout: null,

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        user: null,
        recommendations: [
          {
            recommendation_list_id: null,
            influencer: [],
          },
        ],
      },
      // End:: Data Collection To Send
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: Repeater Methods
    addRow() {
      this.data.recommendations.push({
        recommendation_list_id: null,
        influencer: [],
      });
    },
    removeRow(index) {
      this.data.recommendations.splice(index, 1);
    },
    async onAddListTag(newTag, index) {
      if (!newTag || !newTag.trim()) return;
      const trimmedTag = newTag.trim();

      // Check if already exists in list
      const existing = this.recommendationLists.find(
        (list) =>
          list.name?.toLowerCase() === trimmedTag.toLowerCase() ||
          list.name_ar?.toLowerCase() === trimmedTag.toLowerCase() ||
          list.name_en?.toLowerCase() === trimmedTag.toLowerCase()
      );

      if (existing) {
        this.data.recommendations[index].recommendation_list_id = existing;
        return;
      }

      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("name[ar]", trimmedTag);
      REQUEST_DATA.append("name[en]", trimmedTag);
      REQUEST_DATA.append("is_active", 1);

      try {
        let res = await this.$axios({
          method: "POST",
          url: "recommendation-lists",
          data: REQUEST_DATA,
        });

        const createdItem = res.data.data.RecommendationList || res.data.data;
        const newItem = {
          id: createdItem.id,
          name: createdItem.name_ar || createdItem.name || trimmedTag,
          name_ar: createdItem.name_ar || trimmedTag,
          name_en: createdItem.name_en || trimmedTag,
          ...createdItem,
        };

        this.recommendationLists.push(newItem);
        this.data.recommendations[index].recommendation_list_id = newItem;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
      } catch (error) {
        console.error(error);
        this.$message.error(error.response?.data?.message || error.message);
      }
    },
    // End:: Repeater Methods

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = {
        user_id: this.data.user?.id,
        recommendations: this.data.recommendations.map((item) => {
          const influencers = Array.isArray(item.influencer)
            ? item.influencer
            : item.influencer
            ? [item.influencer]
            : [];

          return {
            recommendation_list_id:
              item.recommendation_list_id?.id || item.recommendation_list_id,
            influencers: influencers
              .map((influencer) => influencer?.id)
              .filter(Boolean),
          };
        }),
      };

      try {
        await this.$axios({
          method: "POST",
          url: `recommendations`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/recommendations/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Get Users
    mapUsers(items) {
      return items.map((item) => ({
        id: item.id,
        name: item.name || item.email,
        ...item,
      }));
    },
    mergeSelectedUser(list) {
      if (!this.data.user) return list;
      const exists = list.some((user) => user.id === this.data.user.id);
      return exists ? list : [this.data.user, ...list];
    },
    async getUsers(reset = true) {
      if (!reset && this.usersLoading) return;

      try {
        this.usersLoading = true;
        if (reset) {
          this.usersPage = 1;
        }

        const params = {
          page: this.usersPage,
          limit: 20,
          is_active: 1,
          ignorePermissionCheck: 1,
        };
        if (this.usersSearch) {
          params.name = this.usersSearch;
        }

        let res = await this.$axios({
          method: "GET",
          url: "clients",
          params,
        });
        const newUsers = this.mapUsers(res.data.data.data || []);
        if (reset) {
          this.users = this.mergeSelectedUser(newUsers);
        } else {
          const existingIds = this.users.map((user) => user.id);
          newUsers.forEach((user) => {
            if (!existingIds.includes(user.id)) {
              this.users.push(user);
            }
          });
        }
        this.usersHasMore = newUsers.length === 20;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      } finally {
        this.usersLoading = false;
      }
    },
    searchUsers(query) {
      clearTimeout(this.usersSearchTimeout);
      this.usersSearchTimeout = setTimeout(() => {
        this.usersSearch = query || "";
        this.getUsers(true);
      }, 400);
    },
    async loadMoreUsers() {
      if (this.usersLoading || !this.usersHasMore) return;
      this.usersPage++;
      await this.getUsers(false);
    },
    // End:: Get Users

    mapInfluencers(items) {
      return items.map((item) => ({
        id: item.id,
        name: item.name || item.nick_name,
        ...item,
      }));
    },
    mergeSelectedInfluencers(list) {
      const selected = [];
      this.data.recommendations.forEach((item) => {
        const influencers = Array.isArray(item.influencer)
          ? item.influencer
          : item.influencer
          ? [item.influencer]
          : [];
        influencers.forEach((influencer) => {
          if (influencer && !selected.find((row) => row.id === influencer.id)) {
            selected.push(influencer);
          }
        });
      });
      const selectedIds = selected.map((influencer) => influencer.id);
      const merged = [...selected];
      list.forEach((influencer) => {
        if (!selectedIds.includes(influencer.id)) {
          merged.push(influencer);
        }
      });
      return merged;
    },
    // Start:: Get Influencers
    async getInfluencers(reset = true) {
      if (!reset && this.influencersLoading) return;

      try {
        this.influencersLoading = true;
        if (reset) {
          this.influencersPage = 1;
        }

        const params = {
          page: this.influencersPage,
          limit: 20,
          is_active: 1,
          ignorePermissionCheck: 1,
        };
        if (this.influencersSearch) {
          params.name = this.influencersSearch;
        }

        let res = await this.$axios({
          method: "GET",
          url: "influencers",
          params,
        });
        const newInfluencers = this.mapInfluencers(res.data.data.data || []);
        if (reset) {
          this.influencers = this.mergeSelectedInfluencers(newInfluencers);
        } else {
          const existingIds = this.influencers.map((influencer) => influencer.id);
          newInfluencers.forEach((influencer) => {
            if (!existingIds.includes(influencer.id)) {
              this.influencers.push(influencer);
            }
          });
        }
        this.influencersHasMore = newInfluencers.length === 20;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      } finally {
        this.influencersLoading = false;
      }
    },
    searchInfluencers(query) {
      clearTimeout(this.influencersSearchTimeout);
      this.influencersSearchTimeout = setTimeout(() => {
        this.influencersSearch = query || "";
        this.getInfluencers(true);
      }, 400);
    },
    // End:: Get Influencers

    // Start:: Load More Influencers
    async loadMoreInfluencers() {
      if (this.influencersLoading || !this.influencersHasMore) return;
      this.influencersPage++;
      await this.getInfluencers(false);
    },
    // End:: Load More Influencers

    // Start:: Get Recommendation Lists
    async getRecommendationLists() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "recommendation-lists?limit=0&page=0&is_active=1&ignorePermissionCheck=1",
        });
        this.recommendationLists = res.data.data.data.map((item) => ({
          id: item.id,
          name: item.name_ar || item.name || item.name_en,
          ...item,
        }));
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },
    // End:: Get Recommendation Lists
  },
  mounted() {
    this.getUsers();
    this.getInfluencers();
    this.getRecommendationLists();
  },
  beforeDestroy() {
    clearTimeout(this.usersSearchTimeout);
    clearTimeout(this.influencersSearchTimeout);
  },
};
</script>
